import { createArray } from './createArray'

type TOptions = {
  minValue?: number
  maxValue?: number
  length: number
}

/**
 * Generates array of given `length` filled with integers from specified `minValue` to `maxValue`.
 */
export const generateRandomNumberArray = ({ minValue = 4, maxValue = 7, length }: TOptions) => {
  return createArray({
    length,
    value: Math.trunc(minValue + Math.random() * (maxValue - minValue)),
  })
}
